module.exports = __webpack_public_path__ + "assets/img/driver-btn-de87a7d7.png";